import addMinutes from "date-fns/addMinutes";
import Payment from "payment";

const data = require("../settings.json");
export function firstLetterUpper(theString) {
  var newString = theString
    .toLowerCase()
    .replace(/(^\s*\w|[\.\!\?]\s*\w)/g, function (c) {
      return c.toUpperCase();
    });
  return newString;
}

export function convertToSentenceCase(theString) {
  //alert(theString);
  var newString = firstLetterUpper(theString);
  return newString;
}

export const getDefaultDateTime = (minutes = 0) => {
  return addMinutes(new Date(), minutes);
};

export const getImageFolder = () => {
  return data.imageFolder;
};

export const validateEmail = (mail) => {
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
    return true;
  }
  return false;
};

export const handleItemSelection = (
  productCopy,
  variations = [],
  bulkPricing = [],
  note = ""
) => {
  const selectedVariations = variations.filter((x) => x.enabled);
  const product = { ...productCopy };
  let fullDescription = `${product.productName}`;
  let specialPrice = {};
  parseFloat(product.totalPrice.toFixed(2));
  product.variationsPrice = 0;

  if (
    product?.productSpecialPricings &&
    product.productSpecialPricings.length > 0
  ) {
    specialPrice = product.productSpecialPricings.find(
      (x) => x.fromQty <= product.quantity && x.toQty >= product.quantity
    );

    if (specialPrice) {
      product.price = specialPrice.specialPrice;
      product.totalPrice = specialPrice.specialPrice;
    }
  }

  if (bulkPricing.length > 0) {
    specialPrice = bulkPricing.find((x) => x.bulkqty === product.quantity);

    if (specialPrice) {
      product.price = parseFloat(
        specialPrice.bulkprice / product.quantity.toFixed(2)
      );
      product.totalPrice = parseFloat(
        specialPrice.bulkprice / product.quantity.toFixed(2)
      );
    }
  }

  for (let i = 0; i < selectedVariations.length; i++) {
    const variation = selectedVariations[i];
    const selectedSubVariations = variation.subVariations.filter(
      (x) => x.enabled
    );
    product.totalPrice = parseFloat(
      (product.totalPrice + variation.price).toFixed(2)
    );
    product.variationsPrice = product.variationsPrice + variation.price;
    fullDescription = `${fullDescription} \n * ${variation.name} ${
      variation.price > 0 ? `(${variation.price.toFixed(2)})` : ""
    }`;
    for (let j = 0; j < selectedSubVariations.length; j++) {
      const subVariation = selectedSubVariations[j];
      product.totalPrice = parseFloat(
        (product.totalPrice + subVariation.price).toFixed(2)
      );
      product.variationsPrice = product.variationsPrice + subVariation.price;
      fullDescription = `${fullDescription} \n * ${subVariation.name} ${
        subVariation.price > 0 ? `(${subVariation.price.toFixed(2)})` : ""
      }`;
    }
  }

  if (note) fullDescription = fullDescription + ` \n **${note}`;
  Object.assign(product, { fullDescription: fullDescription });

  return product;
};

const calculateItems = (
  product,
  taxes,
  ApplyTakeOutDeliveryPrice,
  orderType
) => {
  let orderItem = {
    id: product.id || 0,
    productId: product.productId,
    productCode: product.productCode,
    name: product.productName ? product.productName : product.fullDescription,
    quantity: product.quantity,
    price:
      ApplyTakeOutDeliveryPrice === "1"
        ? orderType === "Delivery"
          ? product.deliveryprice
          : product.takeoutprice
        : product.price,
    variationsPrice:
      parseFloat((product.variationsPrice * product.quantity).toFixed(2)) || 0,
    totalUnitPrice:
      product?.totalUnitPrice > 0
        ? product?.totalUnitPrice
        : product.totalPrice || 0,
    subTotal:
      product?.totalUnitPrice > 0
        ? parseFloat((product?.totalUnitPrice * product.quantity).toFixed(2))
        : parseFloat(((product.totalPrice || 0) * product.quantity).toFixed(2)),
    fullDescription: product.fullDescription,
    printToKitchen1: product.printToKitchen1,
    printToKitchen2: product.printToKitchen2,
    printToKitchen3: product.printToKitchen3,
    printToKitchen4: product.printToKitchen4,
    printToKitchen5: product.printToKitchen5,
    taxId1: product.taxId1 || 0,
    taxId2: product.taxId2 || 0,
    taxId3: product.taxId3 || 0,
    taxId4: product.taxId4 || 0,
    taxId5: product.taxId5 || 0,
    taxId6: product.taxId6 || 0,
    taxRate1: 0,
    taxRate2: 0,
    taxRate3: 0,
    taxRate4: 0,
    taxRate5: 0,
    taxRate6: 0,
    taxPerUnit1: 0,
    taxPerUnit2: 0,
    taxPerUnit3: 0,
    taxPerUnit4: 0,
    taxPerUnit5: 0,
    taxPerUnit6: 0,
    totalTax1: 0,
    totalTax2: 0,
    totalTax3: 0,
    totalTax4: 0,
    totalTax5: 0,
    totalTax6: 0,
    itemTotal: 0,
    status: product.status,
  };
  const selectedVariations = product.selectedVariations || [];
  let tax1 = {};
  let tax2 = {};
  let tax3 = {};
  let tax4 = {};
  let tax5 = {};
  let tax6 = {};

  if (
    product.taxId1 > 0 &&
    taxes.find((x) => x.id === product.taxId1) &&
    orderItem.totalUnitPrice > 0
  ) {
    tax1 = taxes.find((x) => x.id === product.taxId1);
    orderItem.taxRate1 = tax1.rate;
    orderItem.taxPerUnit1 =
      orderItem.totalUnitPrice * (orderItem.taxRate1 / 100);
  }

  if (
    product.taxId2 > 0 &&
    taxes.find((x) => x.id === product.taxId2) &&
    orderItem.totalUnitPrice > 0
  ) {
    tax2 = taxes.find((x) => x.id === product.taxId2);
    orderItem.taxRate2 = tax2.rate;
    orderItem.taxPerUnit2 =
      orderItem.totalUnitPrice * (orderItem.taxRate2 / 100);
  }

  if (
    product.taxId3 > 0 &&
    taxes.find((x) => x.id === product.taxId3) &&
    orderItem.totalUnitPrice > 0
  ) {
    tax3 = taxes.find((x) => x.id === product.taxId3);
    orderItem.taxRate3 = tax3.rate;
    orderItem.taxPerUnit3 =
      orderItem.totalUnitPrice * (orderItem.taxRate3 / 100);
  }
  if (
    product.taxId4 > 0 &&
    taxes.find((x) => x.id === product.taxId4) &&
    orderItem.totalUnitPrice > 0
  ) {
    tax4 = taxes.find((x) => x.id === product.taxId4);
    orderItem.taxRate4 = tax4.rate;
    orderItem.taxPerUnit4 =
      orderItem.totalUnitPrice * (orderItem.taxRate4 / 100);
  }

  if (
    product.taxId5 > 0 &&
    taxes.find((x) => x.id === product.taxId5) &&
    orderItem.totalUnitPrice > 0
  ) {
    tax5 = taxes.find((x) => x.id === product.taxId5);
    orderItem.taxRate5 = tax5.rate;
    orderItem.taxPerUnit5 =
      orderItem.totalUnitPrice * (orderItem.taxRate5 / 100);
  }

  if (
    product.taxId6 > 0 &&
    taxes.find((x) => x.id === product.taxId6) &&
    orderItem.totalUnitPrice > 0
  ) {
    tax6 = taxes.find((x) => x.id === product.taxId6);
    orderItem.taxRate6 = tax6.rate;
    orderItem.taxPerUnit6 =
      orderItem.totalUnitPrice * (orderItem.taxRate6 / 100);
  }

  for (let j = 0; j < selectedVariations.length; j++) {
    const variation = product.selectedVariations[j];
    const subVariations =
      variation?.subVariations?.filter((x) => x.enabled) || [];
    const variationItem = {
      variationId: variation.id,
      price: variation.price,
      subVariations: [],
    };
    for (let k = 0; k < subVariations.length; k++) {
      const subVariation = subVariations[k];
      const subVariationItem = {
        subVariationId: subVariation.id,
        price: subVariation.price,
      };
      variationItem.subVariations.push(subVariationItem);
    }
  }
  return orderItem;
};

export const calculateOrderTotal = (params) => {
  const {
    orders,
    taxes,
    promoCode,
    serviceCharges,
    ApplyTakeOutDeliveryPrice,
    AllowDiscountOnDelivery,
    AllowDiscountOnPickup,
    OnlineSpecialDiscount,
    OnlineCombineLineQty,
    orderType,
  } = params;
  try {
    let serviceChargeAcc = 0;
    let splDiscount = 0;
    let order = {
      clientId: -1,
      clientName: "",
      phoneNumber: "",
      paymentType: "onCounter",
      notes: "",
      taxId1: 0,
      taxId2: 0,
      taxId3: 0,
      taxId4: 0,
      taxId5: 0,
      taxId6: 0,
      totalTax1: 0,
      totalTax2: 0,
      totalTax3: 0,
      totalTax4: 0,
      totalTax5: 0,
      totalTax6: 0,
      stationId: 0,
      subTotal: 0,
      orderTotal: 0,
      serviceCharge: 0,
      promoCode: "",
      promoDiscount: 0,
      serviceFee: 0,
      bagFee: 0,
      serviceFee: 0,
      tip: 0,
      OrderDetails: [],
    };

    let orderTotal = 0;

    for (let i = 0; i < orders.length; i++) {
      let orderItem = calculateItems(
        orders[i],
        taxes,
        ApplyTakeOutDeliveryPrice,
        orderType
      );
      orderItem.totalTax1 += orderItem.taxPerUnit1 * orderItem.quantity;
      orderItem.totalTax2 += orderItem.taxPerUnit2 * orderItem.quantity;
      orderItem.totalTax3 += orderItem.taxPerUnit3 * orderItem.quantity;
      orderItem.totalTax4 += orderItem.taxPerUnit4 * orderItem.quantity;
      orderItem.totalTax5 += orderItem.taxPerUnit5 * orderItem.quantity;
      orderItem.totalTax6 += orderItem.taxPerUnit6 * orderItem.quantity;

      order.totalTax1 += orderItem.totalTax1;
      order.totalTax2 += orderItem.totalTax2;
      order.totalTax3 += orderItem.totalTax3;
      order.totalTax4 += orderItem.totalTax4;
      order.totalTax5 += orderItem.totalTax5;
      order.totalTax6 += orderItem.totalTax6;

      orderItem.itemTotal =
        Math.round(
          (orderItem.subTotal +
            orderItem.totalTax1 +
            orderItem.totalTax2 +
            orderItem.totalTax3 +
            orderItem.totalTax4 +
            orderItem.totalTax5 +
            orderItem.totalTax6 +
            Number.EPSILON) *
            100
        ) / 100;

      orderTotal += orderItem.subTotal;
      order.OrderDetails.push(orderItem);
    }

    if (order.totalTax1 > 0) {
      order.taxId1 = 1;
    }
    if (order.totalTax2 > 0) {
      order.taxId2 = 2;
    }
    if (order.totalTax3 > 0) {
      order.taxId3 = 3;
    }
    if (order.totalTax4 > 0) {
      order.taxId4 = 4;
    }
    if (order.totalTax5 > 0) {
      order.taxId5 = 5;
    }
    if (order.totalTax6 > 0) {
      order.taxId6 = 6;
    }

    order.subTotal = parseFloat(orderTotal.toFixed(2));
    if (order.subTotal > 0) {
      serviceCharges.map((serviceCharge) => {
        if (serviceCharge.isPercentage == 1) {
          serviceChargeAcc +=
            Math.round(
              (order.subTotal * (serviceCharge.amount / 100) + Number.EPSILON) *
                100
            ) / 100;
        } else {
          serviceChargeAcc += serviceCharge.amount;
        }
      });
    }
    if (
      (orderType === "Delivery" && AllowDiscountOnDelivery === "1") ||
      (orderType === "Takeout" && AllowDiscountOnPickup === "1")
    ) {
      splDiscount +=
        Math.round(
          (order.subTotal * (OnlineSpecialDiscount / 100) + Number.EPSILON) *
            100
        ) / 100;
      //  order.subTotal = order.subTotal - splDiscount;
    }

    order.serviceCharge = serviceChargeAcc;

    order.orderTotal = parseFloat(
      (
        order.subTotal +
        order.totalTax1 +
        order.totalTax2 +
        order.totalTax3 +
        order.totalTax4 +
        order.totalTax5 +
        order.totalTax6 +
        serviceChargeAcc
      ).toFixed(2)
    );

    if (promoCode?.code) {
      order.promoCode = promoCode.code;
      if (promoCode.type == 1) {
        order.promoDiscount =
          Math.round(
            (order.subTotal * (promoCode.amount / 100) + Number.EPSILON) * 100
          ) / 100;
        order.oldSubTotal = order.subTotal;
        order.subTotal =
          Math.round(
            (order.subTotal - order.promoDiscount + Number.EPSILON) * 100
          ) / 100;
      } else {
        order.promoDiscount = promoCode.amount;
        order.oldSubTotal = order.subTotal;
        order.subTotal = order.subTotal - promoCode.amount;
      }

      order.oldTotalTax =
        order.totalTax1 +
        order.totalTax2 +
        order.totalTax3 +
        order.totalTax4 +
        order.totalTax5 +
        order.totalTax6;

      order.orderTotal =
        Math.round(
          (order.subTotal +
            order.totalTax1 +
            order.totalTax2 +
            order.totalTax3 +
            order.totalTax4 +
            order.totalTax5 +
            order.totalTax6 +
            serviceChargeAcc +
            Number.EPSILON) *
            100
        ) / 100;
    }

    return order;
  } catch (error) {
    console.log(error);
  }
};

function clearNumber(value = "") {
  return value.replace(/\D+/g, "");
}

export function formatCreditCardNumber(value) {
  if (!value) {
    return value;
  }

  const issuer = Payment.fns.cardType(value);
  const clearValue = clearNumber(value);
  let nextValue;

  switch (issuer) {
    case "amex":
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
        4,
        10
      )} ${clearValue.slice(10, 15)}`;
      break;
    case "dinersclub":
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
        4,
        10
      )} ${clearValue.slice(10, 14)}`;
      break;
    default:
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
        4,
        8
      )} ${clearValue.slice(8, 12)} ${clearValue.slice(12, 19)}`;
      break;
  }

  return nextValue.trim();
}

export function formatCVC(value, prevValue, allValues = {}) {
  const clearValue = clearNumber(value);
  let maxLength = 3;

  if (allValues.number) {
    const issuer = Payment.fns.cardType(allValues.number);
  }

  return clearValue.slice(0, maxLength);
}

export function formatExpirationDate(value) {
  const clearValue = clearNumber(value);

  if (clearValue.length >= 3) {
    return `${clearValue.slice(0, 2)}/${clearValue.slice(2, 4)}`;
  }

  return clearValue;
}
